<div *ngFor="let projetSchemaDescr of schemaForms?.allProjetSchemaDescr; let i = index">
    <app-display-projet-agence
      [projetSchemaDescr]="projetSchemaDescr"
      [form]="schemaForms.allProjetAgenceForm[i]"
      [allProjetAgence]="resultProjetAgence"
      [agenceId]="agenceId"
      (changeProjetEmit)="emitChange()"
    >
    </app-display-projet-agence>
  </div>